import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";

import ContactTop from "@components/antiviruschoice/contactTop";
import FormSection from "@components/antiviruschoice/formSection";

import ComparePEORatesWrapper from "@components/layouts/comparepeoratesWrapper";
export default function NextAutoWarrantyHome(): ReactElement {
    return (
        <ComparePEORatesWrapper>
            <div className={`max-w-7xl mx-auto block px-4vw lg:px-4`}>
                <div className="bg-white">
                    <ContactTop iconsFillColor="#0582b0" />
                </div>
                <FormSection iconsFillColor="#0582b0" />
            </div>
        </ComparePEORatesWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
